import { SlidersHorizontal } from "lucide-react";

const SELECT = "bg-[#09090b] border border-[#3f3f46] text-[#fafafa] px-3 py-2 text-sm outline-none focus:border-[#c8aa6e]";

// Client-side filter bar for AI results (city / source / min-score / has-phone).
export default function AISearchFilters({
  cities, srcs, fCity, setFCity, fSource, setFSource, fScore, setFScore,
  fPhone, setFPhone, filteredCount, totalCount, categoryLabel,
}) {
  return (
    <div className="bg-[#18181b] border border-[#27272a] px-4 py-3 flex flex-wrap items-center gap-3" data-testid="ai-filters">
      <span className="label-tiny inline-flex items-center gap-1.5"><SlidersHorizontal className="w-3.5 h-3.5" /> Filtrar resultados</span>
      <select value={fCity} onChange={(e) => setFCity(e.target.value)} className={SELECT} data-testid="ai-filter-city">
        <option value="">Todas as cidades</option>
        {cities.map((c) => <option key={c} value={c}>{c}</option>)}
      </select>
      <select value={fSource} onChange={(e) => setFSource(e.target.value)} className={SELECT} data-testid="ai-filter-source">
        <option value="">Todos os sites</option>
        {srcs.map(([k, n]) => <option key={k} value={k}>{n}</option>)}
      </select>
      <select value={fScore} onChange={(e) => setFScore(Number(e.target.value))} className={SELECT} data-testid="ai-filter-score">
        <option value={0}>Qualquer relevância</option>
        <option value={50}>Relevância ≥ 50%</option>
        <option value={80}>Relevância ≥ 80%</option>
      </select>
      <label className="text-xs text-[#a1a1aa] inline-flex items-center gap-2">
        <input type="checkbox" checked={fPhone} onChange={(e) => setFPhone(e.target.checked)} className="accent-[#c8aa6e]" data-testid="ai-filter-phone" /> Só com número
      </label>
      <span className="ml-auto text-xs text-[#71717a]" data-testid="ai-results-count">{filteredCount} de {totalCount} resultados · {categoryLabel}</span>
    </div>
  );
}
